// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__JLApI","icon":"style_icon__2_nL-","avatar":"style_avatar__833wj","menuIcon":"style_menuIcon__Hl1K7"};